// No common smart banner for all brands,
// each brand can implement it on its own

const SmartBanner = () => {
  return null;
};

export const standalone = SmartBanner;

export default SmartBanner;
